export default {"src":"/_next/static/media/snowscan.1d03dfbf.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};